export class PasswordResetRequiredException extends Error {}
